import { Layout } from '../types/layout';

export const MODULAR_TEXT_ONLY: Layout = {
  tag: 'default',
  id: 'modular-text-only',
  description: 'Text only',
  handlebarTemplate: `
      <style>
        * { margin: 0; padding: 0; }
        {{{objectStylesCSS}}}
        {{{paragraphStylesCSS}}}
        header {
          flex-shrink: 0;
          text-transform: uppercase;
        }
        .container {
          display: grid;
          grid-template-rows: auto 1fr;
          height: 100%;
        }
        #ad-content {
          align-self: center;
        }
      </style>
      <div class="container">
        {{#with (getDynamicSection dynamicSections "header")}}
          <header class="{{objectClass}}">
            <h1 class="{{textClass}}">{{{content}}}</h1>
          </header>
        {{/with}}
        <section id="ad-content" style="{{{textStyles}}}">
          <div>
            <h2 class="heading-2">{{{title}}}</h2>
            {{{content}}}
            {{#with (getDynamicSection dynamicSections "call-to-action")}}
              <div class="{{objectClass}}">
                <div class="{{textClass}}">{{{content}}}</div>
              </div>
            {{/with}}
            {{#with (getDynamicSection dynamicSections "footer")}}
              <div class="{{objectClass}}">
                <div class="{{textClass}}">{{{content}}}</div>
              </div>
            {{/with}}
          </div>
        </section>
      </div>
    `,
  columns: 3,
  iconSvgUrl:
    'https://enotice-production.imgix.net/custom-documents/permalink/1716673363185/template_g_normal.svg',
  photoAlignment: 'none',
  aspectRatio: 'none',
  photoWidth: 'none'
};

export const FREEFORM_IMAGE: Layout = {
  tag: 'default',
  id: 'freeform-image',
  description: 'Camera ready / pre-built ad',
  bodyConfig: { hidden: true },
  titleConfig: { hidden: true },
  handlebarTemplate: `
      <style>
        * { margin: 0; padding: 0; }
        {{{objectStylesCSS}}}
        {{{paragraphStylesCSS}}}
        header {
          flex-shrink: 0;
          text-transform: uppercase;
        }
        .container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .image-container {
          flex: 1;
          min-height: 0;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center; 
        }
        img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
        }
      </style>
      <div class="container">
        {{#with (getDynamicSection dynamicSections "header")}}
          <header class="{{objectClass}}">
            <h1 class="{{textClass}}">{{{content}}}</h1>
          </header>
        {{/with}}
        <div class="image-container">
          <img src="{{{headerImage}}}" alt="Header Image">
        </div>
      </div>
    `,
  columns: 3,
  images: [{ position: 'top' }],
  iconSvgUrl:
    'https://enotice-production.imgix.net/custom-documents/permalink/1730126534716/onecol_43.svg',
  photoAlignment: 'center',
  aspectRatio: 'none',
  photoWidth: 'none'
};

export const FREEFORM_IMAGE_BOTTOM_TEXT: Layout = {
  tag: 'default',
  id: 'freeform-image-bottom-text',
  description: 'Text, 1 photo at the top',
  handlebarTemplate: `
      <style>
        * { margin: 0; padding: 0; }
        {{{objectStylesCSS}}}
        {{{paragraphStylesCSS}}}
        header {
          flex-shrink: 0;
          text-transform: uppercase;
        }
        .container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .image-container {
          flex: 1;
          min-height: 30%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center; 
        }
        img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
        }
      </style>
      <div class="container">
        {{#with (getDynamicSection dynamicSections "header")}}
          <header class="{{objectClass}}">
            <h1 class="{{textClass}}">{{{content}}}</h1>
          </header>
        {{/with}}
        <div class="image-container">
          <img src="{{{headerImage}}}" alt="Header Image">
        </div>
        <h2 class="heading-2">{{{title}}}</h2>
        <section id="ad-content" style="{{{textStyles}}}; font-weight:normal;">
          {{{content}}}
          {{#with (getDynamicSection dynamicSections "call-to-action")}}
            <div class="{{objectClass}}">
              <div class="{{textClass}}">{{{content}}}</div>
            </div>
          {{/with}}
          {{#with (getDynamicSection dynamicSections "footer")}}
            <div class="{{objectClass}}">
              <div class="{{textClass}}">{{{content}}}</div>
            </div>
          {{/with}}
        </section>
      </div>
    `,
  columns: 3,
  titleConfig: { optional: true },
  bodyConfig: { optional: true },
  images: [{ position: 'top' }],
  iconSvgUrl:
    'https://cdn.column.us/custom-documents%2Fpermalink%2F1761665362658%2Ffreeform_image_bottom_text.svg',
  photoAlignment: 'center',
  aspectRatio: 'none',
  photoWidth: 'none'
};

export const FREEFORM_IMAGE_TOP_TEXT: Layout = {
  tag: 'default',
  id: 'freeform-image-top-text',
  description: 'Text, 1 photo at the bottom',
  handlebarTemplate: `
      <style>
        * { margin: 0; padding: 0; }
        {{{objectStylesCSS}}}
        {{{paragraphStylesCSS}}}
        header {
          flex-shrink: 0;
          text-transform: uppercase;
        }
        .container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .image-container {
          flex: 1;
          min-height: 30%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center; 
        }
        img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
        }
      </style>
      <div class="container">
        {{#with (getDynamicSection dynamicSections "header")}}
          <header class="{{objectClass}}">
            <h1 class="{{textClass}}">{{{content}}}</h1>
          </header>
        {{/with}}
        <h2 class="heading-2">{{{title}}}</h2>
        <section id="ad-content" style="{{{textStyles}}}">
          <div>{{{content}}}</div>
          {{#with (getDynamicSection dynamicSections "call-to-action")}}
            <div class="{{objectClass}}">
              <div class="{{textClass}}">{{{content}}}</div>
            </div>
          {{/with}}
          {{#with (getDynamicSection dynamicSections "footer")}}
            <div class="{{objectClass}}">
              <div class="{{textClass}}">{{{content}}}</div>
            </div>
          {{/with}}
        </section>
        <div class="image-container">
          <img src="{{{headerImage}}}" alt="Header Image">
        </div>
      </div>
    `,
  columns: 3,
  titleConfig: { optional: true },
  bodyConfig: { optional: true },
  images: [{ position: 'bottom' }],
  iconSvgUrl:
    'https://cdn.column.us/custom-documents%2Fpermalink%2F1761665462271%2Ffreeform_image_top_text.svg',
  photoAlignment: 'center',
  aspectRatio: 'none',
  photoWidth: 'none'
};

export const MODULAR_TWO_IMAGE_TOP_TEXT: Layout = {
  tag: 'default',
  id: 'modular-two-image-top-text',
  description: 'Text, 2 photos at the bottom',
  handlebarTemplate: `
      <style>
        * { margin: 0; padding: 0; }
        {{{objectStylesCSS}}}
        {{{paragraphStylesCSS}}}
        header {
          flex-shrink: 0;
          text-transform: uppercase;
        }
        .container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .image-container {
          display: flex;
          max-height: 30%;
          width: 100%;
        }
        img {
          width: 50%;
          object-fit: contain;
        }
      </style>
      <div class="container">
        {{#with (getDynamicSection dynamicSections "header")}}
          <header class="{{objectClass}}">
            <h1 class="{{textClass}}">{{{content}}}</h1>
          </header>
        {{/with}}
        <h2 class="heading-2">{{{title}}}</h2>
        <section id="ad-content" style="{{{textStyles}}}">
          <div>{{{content}}}</div>
          {{#with (getDynamicSection dynamicSections "call-to-action")}}
            <div class="{{objectClass}}">
              <div class="{{textClass}}">{{{content}}}</div>
            </div>
          {{/with}}
          {{#with (getDynamicSection dynamicSections "footer")}}
            <div class="{{objectClass}}">
              <div class="{{textClass}}">{{{content}}}</div>
            </div>
          {{/with}}
        </section>
        <div class="image-container">
          <img src="{{{headerImage}}}" />
          <img src="{{{secondHeaderImage}}}" />
        </div>
      </div>
    `,
  columns: 3,
  titleConfig: { optional: true },
  bodyConfig: { optional: true },
  images: [{ position: 'bottom' }, { position: 'bottom' }],
  iconSvgUrl:
    'https://cdn.column.us/custom-documents%2Fpermalink%2F1761665268201%2Fmodular_two_image_top_text.svg',
  photoAlignment: 'center',
  aspectRatio: 'none',
  photoWidth: 'none'
};

export const FREEFORM_IMAGE_TEXT_ROW: Layout = {
  tag: 'default',
  id: 'freeform-image-text-row',
  description: 'Text, 1 photo at the right',
  handlebarTemplate: `
      <style>
        * { margin: 0; padding: 0; }
        {{{objectStylesCSS}}}
        {{{paragraphStylesCSS}}}
        header {
          flex-shrink: 0;
          text-transform: uppercase;
        }
        .container {
          display: flex;
          flex-direction: column;
          border: 1px solid black;
          height: 100%;
        }
        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          overflow: hidden;
        }
        .content-wrapper {
          max-height: 100%;
        }
        img {
          float: right;
          max-width: 50%;
          max-height: 100%;
        }
      </style>
      <div class="container">
        {{#with (getDynamicSection dynamicSections "header")}}
          <header class="{{objectClass}}">
            <h1 class="{{textClass}}">{{{content}}}</h1>
          </header>
        {{/with}}
        <section class="content" id="ad-content" style="{{{textStyles}}}; font-weight:normal;">
          <div class="content-wrapper">
            <img src="{{{headerImage}}}" alt="Header Image">
            <h2 class="heading-2">{{{title}}}</h2>
            <div>{{{content}}}</div>
            {{#with (getDynamicSection dynamicSections "call-to-action")}}
              <div class="{{objectClass}}">
                <div class="{{textClass}}">{{{content}}}</div>
              </div>
            {{/with}}
            {{#with (getDynamicSection dynamicSections "footer")}}
              <div class="{{objectClass}}">
                <div class="{{textClass}}">{{{content}}}</div>
              </div>
            {{/with}}
          </div>
        </section>
      </div>
    `,
  columns: 3,
  titleConfig: { optional: true },
  bodyConfig: { optional: true },
  images: [{ position: 'top' }],
  iconSvgUrl:
    'https://cdn.column.us/custom-documents%2Fpermalink%2F1761665409302%2Ffreeform_image_text_row.svg',
  photoAlignment: 'center',
  aspectRatio: 'none',
  photoWidth: 'none'
};

export const MODULAR_TWO_IMAGE_TEXT_ROW: Layout = {
  tag: 'default',
  id: 'modular-two-image-text-row',
  description: 'Text, 2 photos at the right',
  handlebarTemplate: `
      <style>
        * { margin: 0; padding: 0; }
        {{{objectStylesCSS}}}
        {{{paragraphStylesCSS}}}
        header {
          text-transform: uppercase;
        }
        .container {
          display: grid;
          grid-template-rows: auto 1fr;
          border: 1px solid black;
          height: 100%;
        }
        .content {
          display: grid;
          height: 100%;
          grid-gap: 0 5px;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: 50% 50%;
        }
        .text-content {
          grid-row-start: span 2;
          align-self: center;
        }
        img {
          max-height: 100%;
          width: 100%;
          align-self: center;
          object-fit: contain; 
        }
      </style>
      <div class="container">
        {{#with (getDynamicSection dynamicSections "header")}}
          <header class="{{objectClass}}">
            <h1 class="{{textClass}}">{{{content}}}</h1>
          </header>
        {{/with}}
        <section id="ad-content" style="{{{textStyles}}}; font-weight:normal;">
          <div class="content">
            <div class="text-content">
              <h2 class="heading-2">{{{title}}}</h2>
              <div>{{{content}}}</div>
              {{#with (getDynamicSection dynamicSections "call-to-action")}}
                <div class="{{objectClass}}">
                  <div class="{{textClass}}">{{{content}}}</div>
                </div>
              {{/with}}
              {{#with (getDynamicSection dynamicSections "footer")}}
                <div class="{{objectClass}}">
                  <div class="{{textClass}}">{{{content}}}</div>
                </div>
              {{/with}}
            </div>
            <img src="{{{headerImage}}}" />
            <img src="{{{secondHeaderImage}}}" />
          </div>
        </section>
      </div>
    `,
  columns: 3,
  titleConfig: { optional: true },
  bodyConfig: { optional: true },
  images: [{ position: 'top' }, { position: 'top' }],
  iconSvgUrl:
    'https://cdn.column.us/custom-documents%2Fpermalink%2F1761665496188%2Fmodular_two_image_text_row.svg',
  photoAlignment: 'center',
  aspectRatio: 'none',
  photoWidth: 'none'
};
